import styled from 'styled-components'
import { Icon } from 'ui/components/Icon'

const Title = styled.div`
  font-weight: normal;
  font-size: 26px;
  line-height: 26px;
  margin: 19px 0px;
  display: flex;
  align-items: center;

  > a {
    color: ${(p) => p.theme.uiKit.colors.global.grey.grey500};
    text-decoration: none;
    font-size: 26px;
    line-height: 26px;
  }
`

const Arrow = styled(Icon)`
  margin: 0 20px;
  opacity: 0.3;
  line-height: 26px;
  font-size: 26px;
`

export const s = { Title, Arrow }
